import dynamic from 'next/dynamic'
import { useTranslation } from 'next-i18next'
import React from 'react'

import Layouts from '@/layouts/Layouts'
import BusinessOpportunities from '@/modules/home/BusinessOpportunities'

import Banner from './Banner'
import Benefit from './Benefit'
import Opening from './Opening'
import PressRelease from './PressRelease'
import TopInvestor from './TopInvestor'
const DistributionMap = dynamic(() => import('./DistributionMap'), { ssr: false })

const Home: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layouts
      title={String(t('home:title'))}
      description={String(t('home:description'))}
    >
      <div className='min-h-screen w-full'>
        <Banner />
        <Opening />
        <DistributionMap />
        <Benefit />
        <BusinessOpportunities />
        <PressRelease />
        <TopInvestor />
      </div>
    </Layouts>
  )
}

export default Home
